import React, { useState, useEffect } from "react";
import Header from "../../../components/header/Header";
import Footer from "../../../components/footer/Footer";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import {
  createPrescChatCompletionForStarpilot,
  getProfile,
  pastoralSummary,
  prescription,
  sendPrescription,
  singleUserAddPrescription,
} from "../../../api/apiHandler";
import PatientInfoPop from "./DoctorInfoPop/index.jsx";
import PatientInfoEditPop from "./PatientInfoEditPop/index.jsx";
import Swal from "sweetalert2";
import queryString from "query-string";
import moment from "moment";
import styled from "styled-components";
import { EmailPrescriptionPopup } from "../../../modal/emailPrescriptionPopup/index.js";
import QRCodePop from "./QrCodePop/index.jsx";
import PriestMeetingRecord from "../meeting-record/PriestMeetingRecord.js";
import NotesModal from "./Notes/PrescriptionNotes.js";
import { TbInfoTriangle } from "react-icons/tb";
function AutoPrescriptionPoc() {
  const navigate = useNavigate();
  const location = useLocation();
  console.log("location.state: ", location.state);
  const params = queryString.parse(window.location.search);
  console.log("params: ", params);
  const userRole = localStorage.getItem("user_login_type_role");
  const [meetingData, setMeetingData] = useState(params);
  console.log("meetingData: ", meetingData);
  const [medicineList, setMedicineList] = useState();
  const [typepres, settypepres] = useState();
  console.log("medicineList: ", medicineList);
  const [patientId, setPatientId] = useState(meetingData.patient_id);
  console.log("patientId: ", patientId);
  const [patiendInfo, setPatientInfo] = useState();
  const [patiendInfoEdit, setPatientInfoEdit] = useState();
  const [patientDataDetails, setPatientDataDetails] = useState(null);
  const [patientData, setPatientData] = useState(null);
  const [patientinfoData, setPatientInfoData] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const handlePatientInfo = () => setPatientInfo(!patiendInfo);
  const handlePatientEditInfo = () => setPatientInfoEdit(!patiendInfoEdit);
  const [qrCodeUrl, setQrCodeUrl] = useState("");
  const [doctorDataDetails, setDoctorDataDetails] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      if (!meetingData) return;

      Swal.fire({
        title: "Please wait...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        const findPrescriptionObj = {
          uuid: meetingData.uuid,
          login_type_role: parseInt(
            localStorage.getItem("user_login_type_role")
          ),
        };

        let response;
        if (userRole === "4" || params?.isPriestMeeting == "true") {
          response = await pastoralSummary(findPrescriptionObj);
        } else {
          response = await createPrescChatCompletionForStarpilot(
            findPrescriptionObj
          );
        }

        const parsedResponse =
          typeof response === "string" ? JSON.parse(response) : response;

        if (!isMounted) return; // prevent state updates on unmount
        Swal.close();

        if (parsedResponse.code === 200) {
          console.log("autopp123", parsedResponse.data);
          setMedicineList(parsedResponse.data.response);
          setPatientId(parsedResponse.data.patient_id);
          setQrCodeUrl(parsedResponse.data.qrCode);
        } else {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: parsedResponse.message,
            toast: true,
            showConfirmButton: false,
            timer: 2000,
          });
        }

        getPatientDetails();
      } catch (error) {
        if (!isMounted) return;
        Swal.close();
        Swal.fire({
          icon: "error",
          title: "Something went wrong",
          text: error.message || "Please try again later",
        });
        console.error("Error fetching data:", error);
      }
    };

    fetchData();

    return () => {
      isMounted = false;
      Swal.close(); // cleanup in case unmounted while loading
    };
  }, [meetingData, userRole]);

  const [qrCode, setQrCode] = useState(false);
  const handleQRCode = () => setQrCode(!qrCode);

  const getPatientDetails = () => {
    getProfile({}).then((response) => {
      response = JSON.parse(response);
      console.log("responseprofile", response);
      if (response.code == process.env.REACT_APP_SUCCESS) {
        setPatientDataDetails(response.data);
        setDoctorDataDetails(response.data);
      }
      // Swal.close()
    });
  };

  const handleSendRx = () => {
    Swal.fire({
      title: "Please wait...",
      didOpen: () => {
        Swal.showLoading();
      },
    });
    var params = {
      // patient_id: patientDataDetails.id,
      meeting_id: meetingData.uuid,
      appointment_id: meetingData.appointment_id,
      prescription_date: moment().utc().format("YYYY-MM-DD"),
      first_name:
        patientDataDetails != null ? patientDataDetails.first_name : null,
      last_name:
        patientDataDetails != null ? patientDataDetails.last_name : null,
      age: patientDataDetails != null ? patientDataDetails.age : 0,
      date_of_birth: null,
      gender: null,
      county: patientDataDetails != null ? patientDataDetails.country : null,
      state: patientDataDetails != null ? patientDataDetails.state : null,
      city: patientDataDetails != null ? patientDataDetails.city : null,
      address: patientDataDetails != null ? patientDataDetails.address : null,
      zipcode: null,
      physician_first_name: null,
      physician_last_name: null,
      additional_direction: null,
      permission_code: null,
    };
    singleUserAddPrescription(params).then((response) => {
      response = JSON.parse(response);
      console.log("response", response);
      if (response.code == process.env.REACT_APP_SUCCESS) {
        const sendRxObj = {
          prescription_id: response.data.id,
          patient_id: patientinfoData?.id,
          appointment_id: meetingData.appointment_id,
        };
        navigate("/doctor/chemist-list", { state: sendRxObj });
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: response.message,
          toast: true,
          showConfirmButton: false,
          timer: 2000,
        });
      }
      Swal.close();
    });
  };
  const isOpenMailModal = () => {
    setIsOpen(true);
  };
  const [openNotes, setOpenNotes] = useState(false);
  const handleViewNotes = () => {
    setOpenNotes(true);
  };

  return (
    <>
      <EmailPrescriptionPopup
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        medicineList={medicineList}
        doctorData={patientDataDetails}
        patientData={patientinfoData}
      />
      <PatientInfoPop
        patientData={patientDataDetails}
        patiendInfo={patiendInfo}
        setPatientInfo={setPatientInfo}
        typepres={typepres}
        mainPrescription={medicineList}
        tempPrescription={medicineList}
      />
      <PatientInfoEditPop
        meetingData={meetingData}
        patiendInfo={patiendInfoEdit}
        setPatientInfo={setPatientInfoEdit}
        setPatientInfoData={setPatientInfoData}
        patientinfoData={doctorDataDetails}
        typepres={typepres}
        mainPrescription={medicineList}
        tempPrescription={medicineList}
      />
      <QRCodePop
        datePresc={moment().utc().format("D MMMM YYYY")}
        qrCodeUrl={qrCodeUrl}
        docData={doctorDataDetails}
        patientData={doctorDataDetails}
        medicineList={medicineList}
        qrCode={qrCode}
        setQrCode={setQrCode}
      />
      <NotesModal show={openNotes} onClose={setOpenNotes} note={medicineList} />
      <main className="bg-color flex-column">
        <Header />

        <section className="doctorsec-pad share-medical">
          <div className="container">
            <div className="card">
              <div className="card-body doctor-table-card">
                {userRole == "4" || params?.isPriestMeeting == "true" ? (
                  <PriestMeetingRecord
                    medicineList={medicineList}
                    handleQRCode={handleQRCode}
                    handlePatientEditInfo={handlePatientEditInfo}
                    isOpenMailModal={isOpenMailModal}
                    handlePatientInfo={handlePatientInfo}
                    meetingData={meetingData}
                    from="singleUser"
                    type={
                      meetingData?.prescriptionType == "tempPres"
                        ? "tempPres"
                        : "final_pres"
                    }
                    settypepres={settypepres}
                  />
                ) : (
                  <>
                    <div className="d-flex justify-content-between align-center mb-3">
                      <div
                        className="content text-black mb-2"
                        style={{ fontFamily: "Aharoni" }}
                      >
                        <h2
                          className="m-0 fw-bold text-center"
                          style={{
                            color: "#216fc8",
                          }}
                        >
                          {userRole == "4"
                            ? meetingData?.prescriptionType == "tempPres"
                              ? "Draft Pastoral Report"
                              : "Pastoral Report"
                            : meetingData?.prescriptionType == "tempPres"
                            ? "Temporary Prescription"
                            : "Final Prescription "}
                        </h2>
                      </div>
                      <button
                        className="px-3 py-2 rounded d-inline-flex align-items-center gap-2 bg-red-50 border border-red-200 shadow-sm hover:bg-red-100 transition-all"
                        onClick={handleViewNotes}
                        style={{ maxWidth: "max-content" }}
                      >
                        <TbInfoTriangle className="text-danger" size={20} />
                        <span className="fw-semibold text-red-700">Notes</span>
                      </button>
                    </div>
                    <div className="table-responsive">
                      <table className="doctor-list-table table table-bordered">
                        <thead>
                          <tr>
                            <th scope="row">Page</th>
                            <th>Name of Drug</th>
                            <th>Strength</th>
                            <th>Strength Type</th>
                            <th>Unit</th>
                            <th>Form</th>
                            <th>Dose</th>
                            <th>Frequency</th>
                            <th>Intakes or Applications</th>
                            <th>Route</th>
                            <th>Refills</th>
                            <th>Quantity</th>
                            <th>Comments</th>
                          </tr>
                        </thead>
                        <tbody>
                          {medicineList &&
                            medicineList.map((item, index) => {
                              return (
                                <tr id={item.id} key={index}>
                                  <td scope="row">{index + 1}</td>
                                  <td>
                                    <h3 className="doc-details">
                                      {item.medicine_name}
                                    </h3>
                                  </td>

                                  <td>{item.strength}</td>
                                  <td>{item.strength_type}</td>
                                  <td>{item.units || item.unit}</td>
                                  <td>{item.form || item.medicine_type}</td>
                                  <td>{item.dose}</td>
                                  <td>{item.frequency}</td>
                                  <td>
                                    {item.intakes_applications || item.intake}
                                  </td>
                                  <td>{item.route}</td>
                                  <td>{item.refills}</td>
                                  <td>{item.quantity}</td>
                                  <td>{item.comments}</td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                    <PocPrescriptionWrpper className="d-flex mt-3 align-items-center justify-content-between flex-wrap gap-10">
                      <button
                        onClick={handleQRCode}
                        className="submit-btn d-inline-flex justify-content-center"
                        style={{ maxWidth: "max-content" }}
                      >
                        QR Codes
                      </button>
                      <button
                        // className="submit-btn justify-content-center"
                        disabled={params?.from === "singleUser"}
                        className={`submit-btn d-inline-flex justify-content-center ${
                          params?.from === "singleUser" && "disabled"
                        }`}
                        style={{ maxWidth: "max-content" }}
                        onClick={handleSendRx}
                      >
                        Send Rx
                      </button>
                      <button
                        // className="submit-btn justify-content-center"
                        disabled={params?.from === "singleUser"}
                        className={`submit-btn d-inline-flex justify-content-center ${
                          params?.from === "singleUser" && "disabled"
                        }`}
                        style={{ maxWidth: "max-content" }}
                        onClick={handleSendRx}
                      >
                        Auto Rx
                      </button>

                      <button
                        disabled={params?.from === "singleUser"}
                        className={`submit-btn d-inline-flex justify-content-center ${
                          params?.from === "singleUser" && "disabled"
                        }`}
                        onClick={handlePatientEditInfo}
                        style={{ maxWidth: "max-content" }}
                      >
                        Patient Info
                      </button>

                      <button
                        onClick={isOpenMailModal}
                        className={
                          medicineList?.length === 0
                            ? "submit-btn d-inline-flex justify-content-center disabled"
                            : "submit-btn d-inline-flex justify-content-center"
                        }
                        style={{
                          maxWidth: "max-content",
                        }}
                        disabled={medicineList?.length === 0}
                      >
                        Mail Prescription
                      </button>

                      <button
                        disabled={params?.from === "singleUser"}
                        className={`submit-btn d-inline-flex justify-content-center ${
                          params?.from === "singleUser" && "disabled"
                        }`}
                        onClick={handlePatientInfo}
                        style={{ maxWidth: "max-content" }}
                      >
                        {userRole == "4" ? "Clergy Info" : "Doctor Info"}
                      </button>
                    </PocPrescriptionWrpper>
                  </>
                )}
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </main>
    </>
  );
}

const PocPrescriptionWrpper = styled.div`
  @media (max-width: 480px) {
    max-width: 300px;
    margin-left: auto;
    margin-right: auto;
    button {
      width: 100%;
      max-width: 100% !important;
    }
  }
`;

export default AutoPrescriptionPoc;
